<template>
  <div class="bg">
    <div class="top">
      <div class="text">
        <div class="title">
          小组座谈会 / 一对一 / 一对二
        </div>
        <div class="value">
          这些方法将一小群目标人群聚集在一起，回答设计好的问题。作为一个群体，受访者可以提供更细致、更自然的反馈。团队动态在发现过程中是强大的，并导致新的想法和新的发现。

          <br />
          虽然我们建议小组座谈会由8名或更少的受访者组成，但一对一 / 一对二 可能被建议作为产生结论的替代方案，同时允许每个受访者有更多时间进行深入提问。

        </div>
        <div><button @click="contact">联系我们</button></div>
      </div>
    </div>

    <div class="picture">
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focus1.jpg">
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focus2.jpg">
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focus3.jpg">
    </div>

    <div class="recommended">
      <div class="title">在以下情况下，建议进行小组座谈会讨论:</div>
      <div class="value">
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focusicon1.png">
          <div class="text">需要达成共识或辩论来探索不同的观点</div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focusicon2.png">
          <div class="text">我们希望为点对点讨论解决方案创造机会</div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focusicon3.png">
          <div class="text">受访者之间的互动可能会引发一场讨论，阐明一个主题，并引出潜在的问题</div>
        </div>
        <div class="box">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focusicon4.png">
          <div class="text">有必要探讨共同趋势</div>
        </div>
      </div>
    </div>

    <div class="eGroup">
      <div class="value">我们的线上定性研究平台<span class="egroup" @click="toguid('/cn/toolbox?source=focus','eGroup')">eGroup</span>可以帮助您加快缩短项目周期，减少差旅成本，并保持在研究范围内。

      </div>
    </div>

    <!-- Qualitative Consultants -->
    <div class="Consultants">
      <div class="img">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/others/consultants.jpg" class="one">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/others/consultants2.jpg" class="two">

      </div>
      <div class="text">
        <div class="title">研究团队</div>
        <div class="value">见见 <a @click="$router.push('/cn/team?source=focus')">我们的研究专家</a>,他们可以在开展您的研究工作时给你最相关的最当地的建议。
        </div>
      </div>
    </div>

    <!-- Case Study -->
    <cn-case-study />

  </div>
</template>

<script>
import CnCaseStudy from "@/components/cncaseStudy";
import { advertisementFlow } from "@/api/api";

export default {
  data() {
    return {};
  },
  created() {
    this.loading();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    this.webinercookies();
  },
  components: {
    CnCaseStudy
  },
  methods: {
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    toguid(path, id) {
      var Id = id;
      localStorage.setItem("toId", Id);
      this.$router.push({ path });
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "focus",
          source: "",
          information: "Solutions_focus"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "focus",
          source: this.$route.query.source,
          information: "Solutions_focus"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    contact() {
      let routeData = this.$router.resolve({ path: "/cn/contact?source=bid" });
      window.open(routeData.href, "_blank");
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    }
  }
};
</script>

<style lang="scss" scoped>
.bg {
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focusbg2.png");
  background-attachment: fixed;
  background-size: cover;
}
.top {
  padding: 60px 200px;
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/focusGroup/focuebg.png");
  background-size: cover;

  // height: 600px;
  .text {
    width: 60%;
    .title {
      width: 70%;
      font-size: 50px;
      font-weight: 700;
      margin-bottom: 25px;
      color: #fff;
    }
    .value {
      font-size: 20px;
      color: #fff;
    }
    button {
      border: none;
      background-color: #2cb1e9;
      color: #fff;
      font-size: 20px;
      border-radius: 10px;
      margin-top: 20px;
      padding: 10px;
    }
  }
}
.picture {
  background-color: #fff;
  padding: 120px 120px;
  display: flex;
  justify-content: space-between;
  img {
    width: 30%;
  }
}
.recommended {
  background-color: #fff;
  padding: 80px 120px;
  text-align: center;
  .title {
    font-size: 40px;
    font-weight: 700;
    padding-bottom: 60px;
  }
  .value {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    // padding: 50px;
    .box {
      width: 20.5%;
      img {
        width: 100px;
        margin-bottom: 30px;
      }
      .text {
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 20px;
      }
    }
  }
}
.eGroup {
  .egroup {
    color: #f56c6c;
    text-decoration: underline;
    cursor: pointer;
    &:hover {
      color: #ff0000;
    }
  }
  padding: 120px;
  background-color: rgba(255, 255, 255, 0.5);
  .value {
    font-size: 35px;
    color: #fff;
    font-weight: 700;
  }
}
.Consultants {
  display: flex;
  padding: 80px 120px;
  position: relative;
  overflow: hidden;
  background-color: #e8eaed;
  .img {
    width: 50%;

    .one {
      position: absolute;
      left: 0;
      top: -40px;
      width: 400px;
      border-radius: 50%;
      border: 6px dotted #f56c6c;
    }
    .two {
      position: absolute;
      top: 230px;
      left: 350px;
      width: 350px;
      border-radius: 20%;
      border: 6px dotted #f56c6c;
    }
  }
  .text {
    width: 50%;
    .title {
      font-size: 40px;
      font-weight: 700;
      color: #f56c6c;
    }
    .value {
      font-size: 23px;
      font-weight: 700;
      // text-align: center;
      padding: 50px;
      color: #003c50;
      a {
        font-size: 30px;
        color: #f56c6c;
        text-decoration: underline;
        &:hover {
          color: #ff0000;
        }
      }
    }
  }
}

@media screen and (max-width: 576px) {
  .top {
    padding: 90px 100px;
    .text {
      width: 100%;
      .title {
        width: 80%;
        font-size: 110px;
      }
      .value {
        font-size: 70px;
      }
      button {
        font-size: 70px;
        padding: 10px 20px;
      }
    }
  }
  .recommended {
    .title {
      font-size: 80px;
    }
    .value {
      .box {
        width: 90%;
        img {
          width: 400px;
        }
        .text {
          font-size: 70px;
          margin-bottom: 200px;
        }
      }
    }
  }
  .eGroup {
    .value {
      font-size: 80px;
    }
  }
  .Consultants {
    display: block;
    .img {
      width: 100%;
      .one {
        width: 800px;
      }
      .two {
        width: 700px;
        top: 500px;
        left: 700px;
      }
    }
    .text {
      width: 100%;
      padding-top: 1000px;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
        a {
          font-size: 75px;
        }
      }
    }
  }
}
</style>